import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div style={{
      height: '100vh',
      backgroundColor: '#1A202C',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#f7fafc',
      textAlign: 'center',
      padding: '1rem'
    }}>
      <h1 style={{ fontSize: '6rem', fontWeight: 'bold', color: '#10B981', margin: 0 }}>404</h1>
      <h2 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Η σελίδα δεν βρέθηκε</h2>
      <p style={{ color: '#a0aec0', marginBottom: '2rem', maxWidth: '400px' }}>
        Μάλλον χαθήκαμε! Η σελίδα που ψάχνετε δεν υπάρχει ή έχει μετακινηθεί.
      </p>
     
      <Link to="/" style={{
        backgroundColor: '#10B981',
        color: 'white',
        padding: '0.75rem 1.5rem',
        borderRadius: '0.5rem',
        textDecoration: 'none',
        fontWeight: '500',
        transition: 'background 0.2s'
      }}>
        Επιστροφή στην Αρχική
      </Link>
    </div>
  );
};

export default NotFoundPage;